module.exports = __webpack_public_path__ + "static/media/react.6cbb89e9.png";